// extracted by mini-css-extract-plugin
module.exports =  {"blocks":"T41ubf_CApfreObblZO6","menu":"Xw7w7KDdNWzbcZoNwf7h","content":"YuucwO_GwsTdFM3r0rg5"};